import StoresService from '@/services/stores'
import StoreNotificationsServices from '@/services/storeNotifications'
import EnvironmentUtils from '@/utils/environmentUtils'

async function initFrame (vuexStore)
{
    const { cityId, cityFeatures } = EnvironmentUtils

    if (!cityFeatures.hasStores) return

    StoresService.fetchStores(cityId).then(stores =>
    {
        vuexStore.commit('stores/updateStoreList', stores)
    })
    StoreNotificationsServices.fetchStoreNotifications(cityId).then(notifs =>
    {
        vuexStore.commit('storeNotifications/updateNotificationList', notifs)
    })
}

export default { initFrame }


// WEBPACK FOOTER //
// ./src/frames/storeFrame.js